"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var SelectEmailProvider_1 = __importDefault(require("./SelectEmailProvider"));
var AutoEmailForwarding = function (_a) {
    var open = _a.open, onClose = _a.onClose, setStep = _a.setStep, _b = _a.vendor, vendor = _b === void 0 ? 'Xero' : _b, props = __rest(_a, ["open", "onClose", "setStep", "vendor"]);
    var _c = __read(react_1.default.useState(), 2), emailProvider = _c[0], setEmailProvider = _c[1];
    var handleClick = function (provider) { return setEmailProvider(provider); };
    var clearSelection = function () { return setEmailProvider(undefined); };
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ open: open, onClose: onClose }, props, { label: "Billing Method", sx: { '& .MuiPaper-root': { maxWidth: 760 } } }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: emailProvider
                        ? "Set up automatic forwarding of ".concat(vendor, " Invoices for ").concat(emailProvider)
                        : 'What email provider are you using?' })) }), (0, jsx_runtime_1.jsx)(ModalContent_1.default, __assign({ minHeight: 150, maxHeight: 600, overflow: "auto" }, { children: (0, jsx_runtime_1.jsx)(SelectEmailProvider_1.default, { emailProvider: emailProvider, handleSelect: handleClick, vendor: vendor }) })), emailProvider && ((0, jsx_runtime_1.jsxs)(ModalFooter_1.default, __assign({ px: 5, py: 3 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "inline-flex", alignItems: "center", justifyContent: "flex-end" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "neutral", size: "large", onClick: onClose, sx: { mr: 3 } }, { children: "I\u2019ll do this later" })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ size: "large", onClick: function () { return setStep === null || setStep === void 0 ? void 0 : setStep().then(onClose); } }, { children: "Forwarding Enabled!" }))] })), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", onClick: clearSelection }, { children: "Go Back" }))] })))] })));
};
exports.default = AutoEmailForwarding;
